module.exports = __webpack_public_path__ + "static/media/search_icon.10c13900.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/search_icon.svg
// module id = 31
// module chunks = 0